var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTalent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9081 11.6425C10.8089 10.673 9.39165 10.1412 7.92593 10.1482C6.47457 10.1368 5.06951 10.6584 3.97722 11.6142C2.88493 12.5699 2.18138 13.8933 2 15.3333",
    stroke: "#2B2B2B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.92586 8.66667C9.76681 8.66667 11.2592 7.17428 11.2592 5.33333C11.2592 3.49238 9.76681 2 7.92586 2C6.08491 2 4.59253 3.49238 4.59253 5.33333C4.59253 7.17428 6.08491 8.66667 7.92586 8.66667Z",
    stroke: "#2B2B2B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5555 7.18518C18.9873 7.18518 20.1481 6.02444 20.1481 4.59259C20.1481 3.16074 18.9873 2 17.5555 2C16.1236 2 14.9629 3.16074 14.9629 4.59259C14.9629 6.02444 16.1236 7.18518 17.5555 7.18518Z",
    stroke: "#2B2B2B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4075 10.1482C21.0539 9.5361 20.5594 9.01721 19.9651 8.63456C19.3707 8.25191 18.6937 8.01653 17.9902 7.94796C17.2867 7.8794 16.5769 7.97962 15.9199 8.24032C15.2629 8.50101 14.6775 8.91466 14.2124 9.44692",
    stroke: "#2B2B2B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5875 11.3526L18.8693 14.7465H21.3647C21.4905 14.7415 21.6148 14.7756 21.7206 14.8442C21.8263 14.9127 21.9084 15.0124 21.9555 15.1294C22.0027 15.2465 22.0126 15.3753 21.984 15.4983C21.9553 15.6212 21.8895 15.7323 21.7955 15.8163L19.6329 17.3298L20.8323 20.0933C20.8847 20.2198 20.8962 20.3596 20.8653 20.4931C20.8343 20.6265 20.7624 20.7468 20.6597 20.8372C20.557 20.9276 20.4286 20.9834 20.2926 20.9968C20.1567 21.0103 20.0199 20.9807 19.9015 20.9122L16.9994 19.2769L14.099 20.9122C13.9806 20.9807 13.8439 21.0103 13.7079 20.9968C13.5719 20.9834 13.4435 20.9276 13.3408 20.8372C13.2381 20.7468 13.1662 20.6265 13.1352 20.4931C13.1043 20.3596 13.1158 20.2198 13.1682 20.0933L14.3685 17.3298L12.2058 15.8163C12.1115 15.7326 12.0454 15.6218 12.0164 15.4989C11.9874 15.3761 11.997 15.2472 12.0439 15.1301C12.0909 15.0129 12.1728 14.9132 12.2784 14.8445C12.3841 14.7758 12.5083 14.7416 12.6342 14.7465H15.1296L16.4138 11.3526C16.4707 11.2461 16.5552 11.157 16.6586 11.0949C16.762 11.0328 16.8802 11 17.0007 11C17.1212 11 17.2394 11.0328 17.3427 11.0949C17.4461 11.157 17.5307 11.2461 17.5875 11.3526Z",
    stroke: "#2B2B2B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTalent);
export default __webpack_public_path__ + "static/media/talent.a1a6e604.svg";
export { ForwardRef as ReactComponent };